{
    "ChangeLang_Title": "Alterar idioma",
    "ChangeLang_Subtitle": "Selecione o idioma no qual deseja visualizar o conteúdo da página da web durante sua sessão atual neste computador.",
    "ChangeLang_Field_Label": "Linguagem",
    "ChangeLang_Remember_Label": "Lembre-se da minha seleção",
    "ChangeLang_Buttons_Apply": "Aplicar",
    "ChangeLang_Buttons_Cancel": "Cancelar",
    "NAME": "ChangeLangLanguage"
}